import nemo from "../assets/logos/nemo.svg"
import ocen from "../assets/logos/ocen.svg"

const brands = {
    nemo: nemo,
    ocen: ocen,
}

export default brands
